<template>
    <v-text-field
            :value="value"
            @input="parseNumber"
            :hint="hint"
            :label="label"
            :clearable="clearable"
            :rules="rules"
            :prepend-icon="prependIcon"
            :append-icon="appendIcon"
    >
    </v-text-field>
</template>

<script>
    export default {
        name: "NumberField",
        props: {
            value: {type: [String, Number]},
            hint: String,
            clearable: {type: Boolean, default: false},
            label: String,
            prependIcon: String,
            appendIcon: String,
            rules: Array,
        },
        methods: {
            parseNumber(value) {
                this.$emit('input', value);
                value = value.toString();
                value = value.substr(0, 10);
                value = value.replace(/[^0-9]/g, '');
                if (value) {
                    value = parseInt(value);
                }
                this.$nextTick(function(){this.$emit('input', value)});
            }
        },
    }
</script>

<style scoped>

</style>
